<template>
  <div>
    <a-form @submit="handleSubmit" :form="form" class="form">
      <a-card title="支付宝支付" class="card" :bordered="true">
        <a-button
          slot="extra"
          size="small"
          :loading="isSubmit"
          v-if="isEdit"
          type="primary"
          @click="handleSubmit">
          提交
        </a-button>
        <a-button slot="extra" size="small" v-if="isEdit" @click="isEdit = false" style="margin-left:15px;">取消</a-button>
        <a-button slot="extra" size="small" v-if="!isEdit" @click="isEdit = true" type="primary">编辑</a-button>
        <!-- <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="账户"
              :labelCol="{lg: {span: 4}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 20}, sm: {span: 20} }">
              <a-input v-show="isEdit" v-decorator="['account',{rules: [{ required: true, message: '请输入账户' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.account || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="账户名称"
              :labelCol="{lg: {span: 4}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 20}, sm: {span: 20} }">
              <a-input v-show="isEdit" v-decorator="['accountName',{rules: [{ required: true, message: '请输入账户名称' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.accountName || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row> -->
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 8}" :lg="{span: 8}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="开启支付"
              :labelCol="{lg: {span: 8}, sm: {span: 8}}"
              :wrapperCol="{lg: {span: 16}, sm: {span: 16} }">
              <a-switch v-if="isEdit" checkedChildren="开" unCheckedChildren="关" v-model="defaultChecked" @change="enableChange"/>
              <span v-if="!isEdit && data.alipay_enable === 'YES'">开启</span>
              <span v-if="!isEdit && data.alipay_enable === 'NO'">关闭</span>
            </a-form-item>
          </a-col>
        </a-row>
        <!-- <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="PID"
              :labelCol="{lg: {span: 4}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 20}, sm: {span: 20} }">
              <a-input v-show="isEdit" v-decorator="['pid',{rules: [{ required: true, message: '请输入PID' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.pid || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row> -->
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="APPID"
              :labelCol="{lg: {span: 4}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 20}, sm: {span: 20} }">
              <a-input v-show="isEdit" v-decorator="['alipay_app_id',{rules: [{ required: true, message: '请输入APPID' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.alipay_app_id || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="商户私钥"
              :labelCol="{lg: {span: 4}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 20}, sm: {span: 20} }">
              <a-input v-show="isEdit" v-decorator="['alipay_private_key',{rules: [{ required: true, message: '请输入商户私钥' }], validateTrigger: 'change'}]"/>
              <a-input v-if="!isEdit" :disabled="true" v-model="data.alipay_private_key"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="支付公钥"
              :labelCol="{lg: {span: 4}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 20}, sm: {span: 20} }">
              <a-input v-show="isEdit" v-decorator="['alipay_public_key',{rules: [{ required: true, message: '请输入支付公钥' }], validateTrigger: 'change'}]"/>
              <a-input v-if="!isEdit" :disabled="true" v-model="data.alipay_public_key"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="异步回调地址"
              :labelCol="{lg: {span: 4}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 20}, sm: {span: 20} }">
              <a-input v-show="isEdit" v-decorator="['alipay_notify_url']"/>
              <a-input v-if="!isEdit" :disabled="true" v-model="data.alipay_notify_url"/>
            </a-form-item>
          </a-col>
        </a-row>
        <!-- <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="同步回调地址"
              :labelCol="{lg: {span: 4}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 20}, sm: {span: 20} }">
              <a-input v-show="isEdit" v-decorator="['alipay_return_url']"/>
              <a-input v-if="!isEdit" :disabled="true" v-model="data.alipay_return_url"/>
            </a-form-item>
          </a-col>
        </a-row> -->
      </a-card>
    </a-form>
  </div>
</template>
<script>
import _ from 'lodash'
import { getPre, saveConfig } from '@/api/system'
import FooterToolBar from '@/components/FooterToolbar'
import { mixin, mixinDevice } from '@/utils/mixin'
import notification from 'ant-design-vue/es/notification'
export default {
  mixins: [mixin, mixinDevice],
  components: {
    FooterToolBar
  },
  created () {
    this.handlePre()
  },
  data () {
    return {
      loading: false,
      isEdit: false,
      isSubmit: false,
      form: this.$form.createForm(this),
      data: {},
      defaultChecked: false
    }
  },
  methods: {
    handlePre () {
      getPre({ type: 'alipay' }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.data = _.get(res, 'data', {})
          this.form.setFieldsValue(this.data)
          if (this.data.alipay_enable === 'YES') {
            this.defaultChecked = true
          }
        }
      })
    },
    enableChange (checked) {
      if (checked) {
        this.data.alipay_enable = 'YES'
      } else {
        this.data.alipay_enable = 'NO'
      }
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = Object.assign(this.data, this.form.getFieldsValue())
          this.isSubmit = true
          saveConfig(data).then(res => {
            if (_.get(res, 'code') === 200) {
              this.handlePre()
              this.isEdit = false
              this.isSubmit = false
              notification.success({
                message: '更新成功',
                description: '保存成功'
              })
            } else {
              this.isSubmit = false
              notification.warning({
                message: '更新失败',
                description: '请稍后再试'
              })
            }
          })
        }
      })
    }
  }
}
</script>
